import React, {useEffect, useRef, useState} from "react";
import {SettingOutlined} from "@ant-design/icons";

import cytoscape from "cytoscape";
import layoutUtilities from 'cytoscape-layout-utilities';
import cola from "cytoscape-cola";
import fcose from "cytoscape-fcose";


import panzoom from 'cytoscape-panzoom';
import 'cytoscape-panzoom/cytoscape.js-panzoom.css';
import {
    AutoComplete,
    Badge,
    Divider,
    Drawer,
    Flex,
    Input,
    message,
    Popover,
    Radio, Slider,
    Space,
    Spin, Switch,
    Tag,
} from 'antd';

import nodes from './nodes_test_2.json';
import edges from './edges.json';
import edges_with_bundles from './edges_with_bundle_index.json';
import teachNodes from './teachers_by_uuid.json';
import teachers from './persons_withNameVariants.json'
import personName from './allPersonsName.json'
// import PowerGrid from "./ThreeGraph.jsx";
import ConcentricGraph from "./concentricGrahph.js";

cytoscape.use(layoutUtilities);
cytoscape.use(cola);
cytoscape.use(fcose);
cytoscape.use(panzoom);

const CytoscapeGraph = () => {
    const containerRef = useRef(null); // 绑定 Cytoscape 容器
    const cyRef = useRef(null); // 存储 Cytoscape 实例
    const [elements, setElements] = useState([...nodes, ...edges_with_bundles]);
    // eslint-disable-next-line
    const [currentEdge, setCurrentEdge] = useState(null);
    const [loading, setLoading] = useState(false);
    const [drawerVisible, setDrawerVisible] = useState(false);
    // const personalInfoRef = useRef(null);
    // const cooperativeRelationshipRef = useRef(null);
    // const [selectedPartnerUUID, setSelectedPartnerUUID] = useState(null);
    const [selectedNode, setSelectedNode] = useState(null); // 存储点击的节点信息
    const [selectedNodeUUID, setSelectedNodeUUID] = useState(null);
    // const {Title, Text} = Typography;

    const [searchOptions, setSearchOptions] = useState([]);
    const handleSearchBarSearch = (value) => {
        const filtered = teachers
            .filter((node) =>
                node.uuid.toLowerCase().includes(value.toLowerCase()) ||
                `${node.name.firstName} ${node.name.lastName}`.toLowerCase().includes(value.toLowerCase())
            )
            .map((node) => {
                const fullName = `${node.name.firstName} ${node.name.lastName}`;
                return {
                    value: node.uuid, // 用 UUID 作为 key
                    label: (
                        <div style={{color: node.active ? 'inherit' : '#888'}}>
                            <span>{fullName}</span>
                            <span style={{margin: '0 8px'}}>–</span>
                            <span>{node.departments}</span>
                            <span style={{marginLeft: 8}}>
                {node.active ? <Tag color="green">In Service</Tag> : <Tag color="default">Leave</Tag>}
              </span>
                        </div>
                    ),
                };
            });

        setSearchOptions(filtered);
    };

    const handleSearchBarSelect = (uuid) => {
        const selectedNode = teachers.find((n) => n.uuid === uuid);
        if (selectedNode) {
            const node = cyRef.current.$id(uuid);
            cyRef.current.animate({
                center: {eles: node},
                zoom: 0.75,
                duration: 1500
            });

            // setTimeout(() => {
            //     // const connectedEdges = node.connectedEdges();
            //     // if (connectedEdges.length === 0) return;
            //     // setSelectedNodeUUID(uuid);
            //     // const selectNode = teachNodes[uuid];
            //     // setSelectedNode(selectNode);
            //     // setDrawerVisible(true);
            //     // setCurrentEdge(connectedEdges);
            //     //
            //     // cyRef.current.edges().forEach((ele) => {
            //     //     if (connectedEdges.some(edge => edge.data("id") === ele.data("id"))) {
            //     //         if (!ele.hasClass("hidden") && !ele.hasClass("highlighted")) {
            //     //             ele.addClass("highlighted");
            //     //         }
            //     //     } else {
            //     //         if (!ele.hasClass("hidden")) {
            //     //             ele.addClass("hidden-dragging");
            //     //         }
            //     //     }
            //     // });
            //     handleCloseDrawer();
            //     const connectedEdges = node.connectedEdges();
            //     const rawConnectedNodes = []
            //     let belongingParents = []
            //     connectedEdges.forEach(edge => {
            //         if (edge.source().id() !== uuid) {
            //             rawConnectedNodes.push(edge.source().id());
            //             // if the source node has a parent , add it to the belongingParents
            //             edge.source().data('parent') && belongingParents.push(edge.source().data('parent'));
            //         }
            //
            //         if (edge.target().id() !== uuid) {
            //             rawConnectedNodes.push(edge.target().id());
            //             edge.source().data('parent') && belongingParents.push(edge.target().data('parent'));
            //         }
            //     });
            //     // remove the duplicated nodes
            //     const connectedNodes = [...new Set(rawConnectedNodes)];
            //     // belongingParents = [...new Set(belongingParents)];
            //     //TODO find the upper parents of the belongingParents
            //     const finalBelongingParents = [...new Set(belongingParents)];
            //     belongingParents.map((parentId => {
            //         const parentNode = cyRef.current.getElementById(parentId);
            //         if (parentNode.data('parent') && !finalBelongingParents.includes(parentNode.data('parent'))) {
            //             finalBelongingParents.push(parentNode.data('parent'));
            //         }
            //     }));
            //     if (connectedEdges.length === 0) return;
            //     setSelectedNodeUUID(uuid);
            //     const selectNode = teachNodes[uuid];
            //     setSelectedNode(selectNode);
            //     setDrawerVisible(true);
            //     setCurrentEdge(connectedEdges);
            //
            //     connectedEdges.forEach(edge => {
            //         edge.style({
            //             // TODO make it straight line
            //             'curve-style': 'straight',
            //         })
            //     })
            //     cyRef.current.edges().forEach((ele) => {
            //         if (connectedEdges.some(edge => edge.data("id") === ele.data("id"))) {
            //             if (!ele.hasClass("hidden") && !ele.hasClass("highlighted")) {
            //                 ele.addClass("highlighted");
            //             }
            //         } else {
            //             if (!ele.hasClass("hidden")) {
            //                 ele.addClass("hidden-dragging");
            //             }
            //         }
            //     });
            //
            //     //TODO make all other nodes invisible
            //     node.addClass("highlighted");
            //     cyRef.current.nodes().forEach((ele) => {
            //         //TODO skip the parent nodes or the connected nodes
            //         if (finalBelongingParents.includes(ele.data("id")) || connectedNodes.includes(ele.data("id")) || ele.data("id") === uuid) {
            //             // console.log("Skipping node: ", ele.data("id"));
            //         } else {
            //             ele.addClass("hidden");
            //         }
            //     });
            //
            //     setIsTappedNode(true);
            //
            // }, 3000); // 等待动画完成
        }
    };


    const [staffOption, setStaffOption] = useState('Default');
    const [edgeOption, setEdgeOption] = useState('Default');

    const [messageApi, contextHolder] = message.useMessage();
    const [isTappedNode, setIsTappedNode] = useState(false);
    const tappedNodeStateRef = useRef(isTappedNode);

    const [unionMode, setUnionMode] = useState(true);
    const unionModeRef = useRef(unionMode);
    const hasInteractedRef = useRef(false);

    useEffect(() => {
        if (!hasInteractedRef.current) return; // 初始化阶段不跑
        unionModeRef.current = unionMode;
        sendStartBundlingMsg();
        edgeBundling();
        // eslint-disable-next-line
    }, [unionMode]);
    useEffect(() => {
        tappedNodeStateRef.current = isTappedNode;
    }, [isTappedNode]);
    const [layoutReady, setLayoutReady] = useState(false);
    const layoutReadyRef = useRef(layoutReady);
    useEffect(() => {
        layoutReadyRef.current = layoutReady;
    }, [layoutReady]);

    const colors = {
        'cyan': 'Teaching',
        'green': 'Research',
        'red': 'Teaching & Research'
    };

    const handleStaffOptionChange = (target) => {
        setLoading(true);
        setTimeout(() => {
            setStaffOption(target.target.value);
            setLoading(false);
        }, 1000);
    };

    const handleEdgeOptionChange = (target) => {
        setLoading(true);
        setTimeout(() => {
            setEdgeOption(target.target.value);
            setLoading(false);
        }, 1000);
    };

    const handleCloseDrawer = () => {
        setDrawerVisible(false);
        // currentEdge.removeClass("highlighted");
        setCurrentEdge(null);
        cyRef.current.edges().removeClass("hidden-dragging");
        cyRef.current.edges().removeClass("highlighted");
        // for those edge style is straight, change it back to segments
        cyRef.current.edges().forEach((ele) => {
            if (ele.style('curve-style') === 'straight') {
                ele.style('curve-style', 'segments');
            }
        });
        cyRef.current.nodes().removeClass("highlighted");
        //TODO Based on the filter conditon remove the hidden class from nodes
        applyOptions()
        cyRef.current.nodes().removeClass("hidden");
        cyRef.current.nodes().forEach((ele) => {
            // if(parseFloat(ele.style('opacity')) <= 0.35) {
            //     console.log("test", ele.style('opacity'), typeof ele.style('opacity'))
            //     ele.style({
            //         'opacity': ele.isParent() ? 1 : ele.data('active') ? 1 : 0.2,
            //         'events': 'yes'
            //     });
            // }
            if (ele.style('font-size')==='50px' && !ele.isParent()) {
                ele.style({
                    'font-size': 24
                });
            }
        })
        setIsTappedNode(false)
    }

    // const CooperativeRelationshipItem = ({data}) => {
    //
    //     const mouseEnter = (_) => {
    //         if (!currentEdge) return;
    //         // find the edge from the current edge
    //         const showingEdges = currentEdge.filter((ele) => !ele.hasClass("hidden"));
    //
    //         const edge = showingEdges.filter((ele) => ele.data("source") === data.partnerUUID || ele.data("target") === data.partnerUUID);
    //         showingEdges.addClass("hidden-dragging");
    //         if (edge) {
    //             edge.removeClass("hidden-dragging").addClass("highlighted");
    //         }
    //
    //     };
    //
    //     const mouseLeave = (_) => {
    //         if (!currentEdge) return;
    //         currentEdge.removeClass("hidden-dragging");
    //         const selectedEdge = currentEdge.filter((ele) => ele.hasClass("highlighted"));
    //         if (selectedEdge) {
    //             selectedEdge.removeClass("highlighted");
    //         }
    //     };
    //
    //     // const [isExternal, setIsExternal] = useState(false);
    //     const [title, setTitle] = useState('Associate');
    //     const [teacher, setTeacher] = useState(null);
    //
    //     useEffect(() => {
    //         const teacher = teachers.find((teacher) => teacher.uuid === data.partnerUUID);
    //         if (!teacher) {
    //             // console.log('Teacher not found', data.partnerUUID);
    //             setTitle('Associate(External)');
    //         }
    //         setTeacher(teacher);
    //     }, [data.partnerUUID]);
    //
    //
    //
    //     const name = getTeacherNameByUUID(data.partnerUUID);
    //
    //     return (
    //         <div onMouseEnter={mouseEnter} onMouseLeave={mouseLeave}>
    //             <Title level={5}>Department</Title>
    //             <Text>{teacher ? teacher.departments : 'External'}</Text>
    //
    //             <Title level={5}>{title}</Title>
    //             <Text copyable>{name}</Text>
    //
    //             <Title level={5}>UUID</Title>
    //             <Text copyable>{data.partnerUUID}</Text>
    //
    //             <Title level={5}>Teaching Courses</Title>
    //             {data.course.length > 0 ? (
    //                 <List
    //                     dataSource={data.course}
    //                     renderItem={(item) => <List.Item>{<Text copyable>{item.courseId}</Text>}</List.Item>}
    //                 />
    //             ) : (
    //                 // <Text type="secondary">Empty</Text>
    //                 <Empty description={<Text type="secondary">Empty</Text>}/>
    //             )}
    //
    //             <Title level={5}>Research</Title>
    //             {data.research.length > 0 ? (
    //                 <List
    //                     dataSource={data.research}
    //                     renderItem={(item) => (
    //                         <List.Item>
    //                             <a href={item.url} target="_blank" rel="noopener noreferrer">
    //                                 {item.title}
    //                             </a>
    //                         </List.Item>
    //                     )}
    //                 />
    //             ) : (
    //                 // <Text type="secondary">Empty</Text>
    //                 <Empty description={<Text type="secondary">Empty</Text>}/>
    //             )}
    //         </div>
    //     );
    // };

    const getLineColor = (ele) => {
        if (ele.data("id").startsWith("R")) return "#2ecc71";
        if (ele.data("id").startsWith("T")) return "#3498db";
        if (ele.data("id").startsWith("B")) return "#ff4500";
    };

    const staffOptions = [
        {
            label: 'Default',
            value: 'Default',
        },
        {
            label: 'Active',
            value: 'Active',
        },
        {
            label: 'Inactive',
            value: 'Inactive',
        },
    ];

    const edgeOptions = [
        {
            label: 'Default',
            value: 'Default',
        },
        {
            label: 'Research',
            value: 'Research',
        },
        {
            label: 'Teaching',
            value: 'Teaching',
        },
        // {
        //     label: 'Hybrid',
        //     value: 'Hybrid',
        // }
    ];

    const getTeacherNameByUUID = (uuid) => {
        if (!uuid) {
            return 'Unknown';
        }
        const person = personName[uuid];
        if (!person) {
            // console.log('Person not found', uuid);
            return 'Unknown';
        }
        return `${person.firstName} ${person.lastName}`;
        // const teacher = teachers.find((teacher) => teacher.uuid === uuid);
        // if (!teacher) {
        //     const person = personName[uuid];
        //     if (!person) {
        //         console.log('Person not found', uuid);
        //         return 'Unknown';
        //     }
        //     return `${person.firstName} ${person.lastName}`;
        // }
        // const firstName = teacher.name.firstName ? teacher.name.firstName : '';
        // const lastName = teacher.name.lastName ? teacher.name.lastName : '';
        // return `${firstName} ${lastName}`;
    }

    const getTeacherByUUID = (uuid) => {
        const teacher = teachers.find((teacher) => teacher.uuid === uuid);
        if (!teacher) {
            // console.log('Teacher not found', uuid);
            return null;
        }
        return teacher;
    }

    // const scrollToTop = () => {
    //     if (personalInfoRef.current) {
    //         personalInfoRef.current.focus();
    //         personalInfoRef.current.scrollIntoView({behavior: "smooth"});
    //     }
    // };

    // const scrollToBottom = (selectedPartnerUUID) => {
    //     setSelectedPartnerUUID(selectedPartnerUUID);
    //     if (cooperativeRelationshipRef.current) {
    //         cooperativeRelationshipRef.current.focus() // 滚动到最底端
    //         cooperativeRelationshipRef.current.scrollIntoView({behavior: "smooth"});
    //     }
    // }

    const sendStartBundlingMsg = () => {
        messageApi
            .open({
                type: 'loading',
                key: 'start',
                content: 'Edge bundling in progress..',
                duration: 0,
                style: {
                    marginTop: '85vh'
                },
            })
    };

    const sendSuccessBundlingMsg = () => {
        messageApi.destroy('start');
        messageApi.open({
            type: 'success',
            key: 'success',
            content: 'Edge bundling finished',
            duration: 2.5,
            style: {
                marginTop: '45vh'
            },
        })
    }

    const sendErrorBundlingMsg = () => {
        messageApi.destroy('start');
        messageApi.open({
            type: 'error',
            key: 'error',
            content: 'Edge bundling failed',
            duration: 2.5,
            style: {
                marginTop: '45vh'
            },
        })
    }

    const edgeBundling = () => {
        if (!cyRef.current) {
            // console.warn("Cytoscape instance not initialized yet.");
            return;
        }
        console.log("Starting edge bundling with union mode:", unionModeRef.current);
        computeEdgeBundling(cyRef.current, {
            bandwidth: 0.7,            // 适当增加带宽
            decay: 0.5,
            iterations: 100,
            union: unionModeRef.current
        }).then(data => {
            data.paths.forEach(({edgeId, segmentWeights, segmentDistances}) => {
                const edge = cyRef.current.getElementById(edgeId);
                edge.data('curvedWeights', segmentWeights);
                edge.data('curvedDistances', segmentDistances);
                const segmentCount = segmentDistances.length;
                const straightDists = Array(segmentCount).fill(0);
                const straightWeights = Array.from(
                    { length: segmentCount },
                    (_, i) => (i + 1) / (segmentCount + 1)
                );
                edge.data('straightWeights', straightWeights);
                edge.data('straightDistances', straightDists);
                // 设置 segmentWeights 和 segmentDistances
                edge.data('segmentWeights', segmentWeights);
                edge.data('segmentDistances', segmentDistances);
                setBundlingStrength(1);
            });
            try {
                cyRef.current.style().selector('edge').style({
                    'curve-style': 'segments',
                    'segment-weights': 'data(segmentWeights)',
                    'segment-distances': 'data(segmentDistances)',
                    'edge-distances': 'node-position'
                }).update();

                // 2) 立刻检测“警告”边（也就是控制点落到端点上的边）
                (() => {
                    const origWarn = console.warn;
                    console.warn = function(msg, ...rest) {
                        // 只拦截 Cytoscape 那种 “invalid endpoints” 警告
                        if (typeof msg === 'string'
                            && msg.startsWith('Edge `')
                            && msg.includes('invalid endpoints')
                        ) {
                            // 抽取 edgeId
                            const m = msg.match(/^Edge `(.+?)`/);
                            if (m) {
                                const badId = m[1];
                                const edge  = cyRef.current.getElementById(badId);
                                if (edge.length) {
                                    // console.log("Found bad edge:", badId);
                                    // 获取当前它要用的 segmentWeights（可能是 data 或 style 里读出来的）
                                    // const weights = edge.data('segmentWeights') || [];
                                    // 立刻把 distances 全部置零
                                    edge.style({
                                        'segment-distances': [0],
                                        // 保留 weights，让它仍然用 segments
                                        'segment-weights':   [0.5]
                                    });
                                }
                            }
                        }
                        // 不干扰其它 warn
                        origWarn.call(console, msg, ...rest);
                    };
                })();
            } catch (e) {
                console.warn("Failed to apply segment style, fallback to bezier", e);
                cyRef.current.style().selector('edge').style({
                    'curve-style': 'loop'
                }).update();
            }
            console.log("Style updated after bundling");
            sendSuccessBundlingMsg()
        }).catch(error => {
            sendErrorBundlingMsg()
            console.error("Edge bundling failed:", error);
        })
    }

    const applyOptions = () => {
        if (staffOption === 'Default' && edgeOption === 'Default') {
            if (cyRef.current) {
                cyRef.current.nodes().removeClass("hidden");
                cyRef.current.edges().removeClass("hidden");
            } else {
                setElements([...nodes, ...edges_with_bundles]);
            }
        }

        if (staffOption === 'Active' && edgeOption === 'Default') {

            const activeNodes = nodes.filter(node => node.data.active || node.data.active === undefined);
            const activeEdges = edges.filter(edge => activeNodes.some(node => node.data.id === edge.data.source) && activeNodes.some(node => node.data.id === edge.data.target));
            // make all nodes and edges invisible except activeNodes and activeEdges
            cyRef.current.nodes().removeClass("hidden");
            cyRef.current.edges().removeClass("hidden");

            // remove the hidden class from activeNodes
            cyRef.current.nodes().forEach((ele) => {
                if (!activeNodes.some(node => node.data.id === ele.data("id"))) {
                    ele.addClass("hidden");
                }
            });
            // remove the hidden class from activeEdges
            cyRef.current.edges().forEach((ele) => {
                if (!activeEdges.some(node => node.data.id === ele.data("id"))) {
                    ele.addClass("hidden");
                }
            });
        }

        if (staffOption === 'Inactive' && edgeOption === 'Default') {
            cyRef.current.nodes().removeClass("hidden");
            cyRef.current.edges().removeClass("hidden");
            const inactiveNodes = nodes.filter(node => !node.data.active);
            const inactiveEdges = edges.filter(edge => inactiveNodes.some(node => node.data.id === edge.data.source) && inactiveNodes.some(node => node.data.id === edge.data.target));

            cyRef.current.nodes().forEach((ele) => {
                if (!inactiveNodes.some(node => node.data.id === ele.data("id"))) {
                    ele.addClass("hidden");
                }
            });

            cyRef.current.edges().forEach((ele) => {
                if (!inactiveEdges.some(node => node.data.id === ele.data("id"))) {
                    ele.addClass("hidden");
                }
            });
        }

        if (staffOption === 'Default' && edgeOption === 'Research') {
            cyRef.current.nodes().removeClass("hidden");
            cyRef.current.edges().removeClass("hidden");

            const researchEdges = edges.filter(edge => edge.data.id.startsWith('R') || edge.data.id.startsWith('B'));
            cyRef.current.edges().forEach((ele) => {
                if (!researchEdges.some(node => node.data.id === ele.data("id"))) {
                    ele.addClass("hidden");
                }
            });

        }

        if (staffOption === 'Default' && edgeOption === 'Teaching') {
            cyRef.current.nodes().removeClass("hidden");
            cyRef.current.edges().removeClass("hidden");

            const teachingEdges = edges.filter(edge => edge.data.id.startsWith('T') || edge.data.id.startsWith('B'));
            cyRef.current.edges().forEach((ele) => {
                if (!teachingEdges.some(node => node.data.id === ele.data("id"))) {
                    ele.addClass("hidden");
                }
            });
        }

        if (staffOption === 'Default' && edgeOption === 'Hybrid') {
            cyRef.current.nodes().removeClass("hidden");
            cyRef.current.edges().removeClass("hidden");

            const hybridEdges = edges.filter(edge => edge.data.id.startsWith('B') || edge.data.id.startsWith('B'));
            cyRef.current.edges().forEach((ele) => {
                if (!hybridEdges.some(node => node.data.id === ele.data("id"))) {
                    ele.addClass("hidden");
                }
            });
        }

        if (staffOption === 'Active' && edgeOption === 'Research') {
            cyRef.current.nodes().removeClass("hidden");
            cyRef.current.edges().removeClass("hidden");

            const activeNodes = nodes.filter(node => node.data.active || node.data.active === undefined);
            const researchEdges = edges.filter(edge => (edge.data.id.startsWith('R') || edge.data.id.startsWith('B')) && activeNodes.some(node => node.data.id === edge.data.source) && activeNodes.some(node => node.data.id === edge.data.target));

            cyRef.current.nodes().forEach((ele) => {
                if (!activeNodes.some(node => node.data.id === ele.data("id"))) {
                    ele.addClass("hidden");
                }
            });

            cyRef.current.edges().forEach((ele) => {
                if (!researchEdges.some(node => node.data.id === ele.data("id"))) {
                    ele.addClass("hidden");
                }
            });

        }

        if (staffOption === 'Active' && edgeOption === 'Teaching') {
            cyRef.current.nodes().removeClass("hidden");
            cyRef.current.edges().removeClass("hidden");

            const activeNodes = nodes.filter(node => node.data.active || node.data.active === undefined);
            const teachingEdges = edges.filter(edge => (edge.data.id.startsWith('T') || edge.data.id.startsWith('B')) && activeNodes.some(node => node.data.id === edge.data.source) && activeNodes.some(node => node.data.id === edge.data.target));

            cyRef.current.nodes().forEach((ele) => {
                if (!activeNodes.some(node => node.data.id === ele.data("id"))) {
                    ele.addClass("hidden");
                }
            });

            const activeNodesIds = activeNodes.map(node => node.data.id);
            cyRef.current.edges().forEach((ele) => {
                if (!teachingEdges.some(node => node.data.id === ele.data("id"))) {
                    ele.addClass("hidden");
                } else {
                    if (!activeNodesIds.includes(ele.data("source")) || !activeNodesIds.includes(ele.data("target"))) {
                        ele.addClass("hidden");
                    }
                }

            });
        }

        if (staffOption === 'Active' && edgeOption === 'Hybrid') {
            cyRef.current.nodes().removeClass("hidden");
            cyRef.current.edges().removeClass("hidden");

            const activeNodes = nodes.filter(node => node.data.active || node.data.active === undefined);
            const hybridEdges = edges.filter(edge => edge.data.id.startsWith('B') && activeNodes.some(node => node.data.id === edge.data.source) && activeNodes.some(node => node.data.id === edge.data.target));

            cyRef.current.nodes().forEach((ele) => {
                if (!activeNodes.some(node => node.data.id === ele.data("id"))) {
                    ele.addClass("hidden");
                }
            });

            cyRef.current.edges().forEach((ele) => {
                if (!hybridEdges.some(node => node.data.id === ele.data("id"))) {
                    ele.addClass("hidden");
                }
            });
        }

        if (staffOption === 'Inactive' && edgeOption === 'Research') {
            cyRef.current.nodes().removeClass("hidden");
            cyRef.current.edges().removeClass("hidden");

            const inactiveNodes = nodes.filter(node => !node.data.active);
            const researchEdges = edges.filter(edge => (edge.data.id.startsWith('R') || edge.data.id.startsWith('B')) && inactiveNodes.some(node => node.data.id === edge.data.source) && inactiveNodes.some(node => node.data.id === edge.data.target));

            cyRef.current.nodes().forEach((ele) => {
                if (!inactiveNodes.some(node => node.data.id === ele.data("id"))) {
                    ele.addClass("hidden");
                }
            });

            cyRef.current.edges().forEach((ele) => {
                if (!researchEdges.some(node => node.data.id === ele.data("id"))) {
                    ele.addClass("hidden");
                }
            });
        }

        if (staffOption === 'Inactive' && edgeOption === 'Teaching') {
            cyRef.current.nodes().removeClass("hidden");
            cyRef.current.edges().removeClass("hidden");

            const inactiveNodes = nodes.filter(node => !node.data.active);
            const teachingEdges = edges.filter(edge => (edge.data.id.startsWith('T') || edge.data.id.startsWith('B')) && inactiveNodes.some(node => node.data.id === edge.data.source) && inactiveNodes.some(node => node.data.id === edge.data.target));

            cyRef.current.nodes().forEach((ele) => {
                if (!inactiveNodes.some(node => node.data.id === ele.data("id"))) {
                    ele.addClass("hidden");
                }
            });

            cyRef.current.edges().forEach((ele) => {
                if (!teachingEdges.some(node => node.data.id === ele.data("id"))) {
                    ele.addClass("hidden");
                }
            });

        }

        if (staffOption === 'Inactive' && edgeOption === 'Hybrid') {
            cyRef.current.nodes().removeClass("hidden");
            cyRef.current.edges().removeClass("hidden");

            const inactiveNodes = nodes.filter(node => !node.data.active);
            const hybridEdges = edges.filter(edge => edge.data.id.startsWith('B') && inactiveNodes.some(node => node.data.id === edge.data.source) && inactiveNodes.some(node => node.data.id === edge.data.target));

            cyRef.current.nodes().forEach((ele) => {
                if (!inactiveNodes.some(node => node.data.id === ele.data("id"))) {
                    ele.addClass("hidden");
                }
            });


            cyRef.current.edges().forEach((ele) => {
                if (!hybridEdges.some(node => node.data.id === ele.data("id"))) {
                    ele.addClass("hidden");
                }
            });
        }
    }

    useEffect(() => {
        applyOptions()
        // eslint-disable-next-line
    }, [staffOption, edgeOption]);

    useEffect(() => {
            if (!containerRef.current && !cyRef.current) return; // 避免重复初始化

            // go though the elements and find the nodes that parent id starts with "Afd" or "Dep", add " Sub" to the end of the parent id
            const updatedElements = elements.map((ele) => {
                if (ele.group === 'nodes' && !ele.data.id.startsWith("Dep") && !ele.data.id.startsWith("Afd") && !ele.data.id.startsWith("Sub")) {
                    if (ele.data.parent.startsWith("Afd") || ele.data.parent.startsWith("Dep")) {
                        return {
                            ...ele,
                            data: {
                                ...ele.data,
                                parent: "Sub " + ele.data.parent
                            }
                        };
                    }
                    return ele;
                }
                return ele;
            });

            cyRef.current = cytoscape({
                container: containerRef.current,
                elements: updatedElements,
                style: [
                    {
                        selector: "node",
                        style: {
                            "background-color": (ele) => {
                                return "#fff";
                            },
                            "opacity": function (ele) {
                                const colorMap = {
                                    // 灰色
                                    "Dep Informatica": "#7f8c8d",
                                    // 小部门 1（蓝色系）
                                    "Afd Interaction": "#1f77b4",
                                    "Sub Human-Centered Computing": "#3498db",
                                    "Sub Multimedia": "#2980b9",
                                    "Sub Visualisation and Graphics": "#2471a3",
                                    "Sub Social and Affective Computing": "#1a5276",
                                    "Sub Music Information Computing": "#154360",
                                    "Sub Cybernetics": "#0d3050",

                                    // 小部门 2（红色系，替代绿色）
                                    "Afd AI & Data Science": "#e74c3c",
                                    "Sub AI Technology for Life": "#f1948a",
                                    "Sub Natural Language Processing": "#c0392b",
                                    "Sub Intelligent Systems": "#d35400",
                                    "Sub Data Intensive Systems": "#922b21",
                                    "Sub Algorithmic Data Analysis": "#7b241c",
                                    "Sub Responsible AI": "#641e16",

                                    // 小部门 3（橙色系）
                                    "Afd Algorithms": "#ff7f0e",
                                    "Sub Algorithms and Complexity": "#ffa07a",
                                    "Sub Simulation of Complex Systems": "#ff8c00",
                                    "Sub Geometric Computing": "#e67e22",

                                    // 小部门 4（紫色系）
                                    "Afd Software": "#9467bd",
                                    "Sub Process Science": "#af7ac5",
                                    "Sub Softw.Techn. for Learning and Teach": "#9b59b6",
                                    "Sub Software Technology": "#76448a",
                                    //     子部门
                                    "Sub Afd Software": "#8e44ad",
                                    "Sub Dep Informatica": "#7d3c98",
                                    "Sub Afd Interaction": "#6c3483",
                                    "Sub Afd AI & Data Science": "#5b2c6f",
                                    "Sub Afd Algorithms": "#4a235a",
                                };
                                if (!Object.keys(colorMap).includes(ele.data('id'))) {
                                    return ele.data('active') ? 1 : 0.2
                                }
                                return 1;

                            },
                            "border-width": 2,
                            "border-color": "#000",
                            "label": (ele) => {
                                return ele.data('active') === undefined ? ele.data('id') : getTeacherNameByUUID(ele.data('id'));
                            },
                            'font-size': (ele) => isTappedNode ? 240: (ele.data('active') === undefined ? 80 : 24),
                            "border-radius": 10,
                            events: (ele) => {
                                if (ele.data('active') === undefined){
                                    return "no"
                                } else {
                                    return "yes"
                                }
                            }
                        },
                    },
                    {
                        selector: "node.hidden", style: {
                            // opacity: 0.35,
                            events: "no",
                            visibility: "hidden",

                        },
                    },
                    {
                        selector: "node.highlighted",
                        style: {
                            "background-color": (ele) => {
                                return "#f1c40f"; // 高亮时的颜色
                            },
                            "border-color": "#e67e22",
                            "border-width": 4,
                            "width": 100,
                            "height": 100,
                            "font-size": 30,
                        },
                    },
                    {
                        selector: 'node.afd-in-dep',
                        style: {
                            shape: 'round-rectangle',
                            borderRadius: 25,
                            'border-width': 3,
                            'border-color': '#ff0000',
                            'border-style': 'solid'
                        }
                    },
                    {
                        selector: "edge",
                        style: {
                            'curve-style': 'segments',
                            "line-color": getLineColor,
                            opacity: 0.333,
                            events: "no",
                        },
                    },
                    {
                        selector: "edge.highlighted",
                        style: {
                            "line-color": getLineColor,
                            width: 16,
                            "line-style": "solid",
                        },
                    },
                    {
                        selector: "edge.hidden",
                        style: {
                            opacity: 0,
                            visibility: "hidden",
                        },
                    },
                    {
                        selector: "edge.hidden-dragging",
                        style: {
                            opacity: 0,
                            visibility: "hidden",
                        },
                    },
                ],
                minZoom: 0.05,           // 允许的最小缩放
                maxZoom: 0.75,             // 允许的最大缩放
                wheelSensitivity: 0.75,  // ↓ 值越小，滚轮一次缩放得越“细”（更慢更平滑）

                // —— 性能相关 ——
                pixelRatio: 1,              // 高DPI设备强制1，可大幅降负载
                hideEdgesOnViewport: true,  // 拖拽/缩放时临时隐藏边（大量边时非常有效）
            });

            cyRef.current.nodes().forEach(n => {
                const id = n.id();
                const parent = n.data('parent');

                if (parent === undefined && (id.startsWith('Afd') || id.startsWith('Sub'))) {
                    n.addClass('afd-in-dep');
                }
            });

            cyRef.current.layout({
                name: "cola",
                randomize: true,
                // animate: true,
                maxSimulationTime: 5000,

                nodeSpacing: (node) => {
                    // if the node is a parent node, return 1000
                    if (node.isParent()) {
                        if(node.id().startsWith("Afd") || node.id() ==="Sub Dep Informatica") {
                            return 300;
                        }
                        if (node.id().startsWith("Sub")) {
                            return 150
                        }
                    }
                    // if the node is not a parent node, return 500
                    if(node.connectedEdges().length === 0) {
                        return 40; // 如果是孤立节点，设置较小的间距
                    }
                    return 80;
                }, // 增加节点间距
                edgeLength: function(edge){
                    let basicLength = 200;
                    const targetNodes = cyRef.current.nodes().find (n => n.id() === edge.target().id());
                    const sourceNodes = cyRef.current.nodes().find (n => n.id() === edge.source().id());
                    if (targetNodes.data('parent') === sourceNodes.data('parent')) {
                        // return 100; // 如果是同一父节点下的边，设置较短的长度
                        basicLength = 100;
                    }
                    if(targetNodes.data('parent') === 'Sub Dep Informatica' ||  sourceNodes.data('parent')=== 'Sub Dep Informatica'){
                        // return 200
                        basicLength = 200;
                    }

                    const parentTarget = cyRef.current.nodes().find (n => n.id() === targetNodes.data('parent'));
                    const parentSource = cyRef.current.nodes().find (n => n.id() === sourceNodes.data('parent'));
                    if(parentTarget.data('parent') === parentSource.data('parent')) {
                        // return 150
                        basicLength = 150;
                    }
                    // return basicLength
                    return basicLength * (1 - edge.data('weight'));
                }, // 控制边长 (默认 50)
                unconstrIter: 40, // 增加迭代次数，让布局更稳定

                flow: { axis: 'y', minSeparation: 20 },   // 强制纵向排列

                // customization
                ready: () => {
                    console.log("Layout ready");
                    setLayoutReady(true);
                },
                stop: () => {
                    console.log("Layout stopped");
                    if (layoutReadyRef.current) {
                        sendStartBundlingMsg();
                        setTimeout(() => {
                            edgeBundling();
                            // 真正检测“坏”边：
                            const badEdges = cyRef.current.edges().filter(e => {
                                const p1 = e.source().position();
                                const p2 = e.target().position();
                                return p1.x === p2.x && p1.y === p2.y;
                            });

                            if (badEdges.length > 0) {
                                console.log("Found bad edges:", badEdges.map(e => e.id()));
                                badEdges.style({
                                    'curve-style': 'straight'   // 或者 loop / haystack
                                });
                            }
                        }, 500);
                    }
                },

                // manually config the layout

            }).run();

            // cyRef.current.panzoom();

            cyRef.current.on("tap", "node", (evt) => {
                console.log("Node clicked: ", evt.target.id());

                const node = evt.target;
                if (node.isParent()) return;


                const connectedEdges = node.connectedEdges();
                if (connectedEdges.length === 0) {
                    return;
                }
                handleCloseDrawer();
                const rawConnectedNodes = []
                let belongingParents = []
                connectedEdges.forEach(edge => {
                    if (edge.source().id() !== evt.target.id) {
                        rawConnectedNodes.push(edge.source().id());
                        // if the source node has a parent , add it to the belongingParents
                        edge.source().data('parent') && belongingParents.push(edge.source().data('parent'));
                    }

                    if (edge.target().id() !== evt.target.id) {
                        rawConnectedNodes.push(edge.target().id());
                        edge.source().data('parent') && belongingParents.push(edge.target().data('parent'));
                    }
                });
                // remove the duplicated nodes
                const connectedNodes = [...new Set(rawConnectedNodes)];
                // belongingParents = [...new Set(belongingParents)];
                //TODO find the upper parents of the belongingParents
                const finalBelongingParents = [...new Set(belongingParents)];
                belongingParents.forEach((parentId => {
                    const parentNode = cyRef.current.getElementById(parentId);
                    if (parentNode.data('parent') && !finalBelongingParents.includes(parentNode.data('parent'))) {
                        finalBelongingParents.push(parentNode.data('parent'));
                    }
                }));
                if (connectedEdges.length === 0) return;
                setSelectedNodeUUID(evt.target.id());
                const selectNode = teachNodes[evt.target.id()];
                setSelectedNode(selectNode);
                setDrawerVisible(true);
                setCurrentEdge(connectedEdges);

                connectedEdges.forEach(edge => {
                    edge.style({
                        // TODO make it straight line
                        'curve-style': 'straight',
                    })
                })
                cyRef.current.edges().forEach((ele) => {
                    if (connectedEdges.some(edge => edge.data("id") === ele.data("id"))) {
                        if (!ele.hasClass("hidden") && !ele.hasClass("highlighted")) {
                            ele.addClass("highlighted");
                        }
                    } else {
                        if (!ele.hasClass("hidden")) {
                            ele.addClass("hidden-dragging");
                        }
                    }
                });

                //TODO make all other nodes invisible
                evt.target.addClass("highlighted");
                cyRef.current.nodes().forEach((ele) => {
                    //TODO skip the parent nodes or the connected nodes
                    if ((finalBelongingParents.includes(ele.data("id")) && ele.isParent()) || connectedNodes.includes(ele.data("id"))) {
                        // console.log("Skipping node: ", ele.data("id"));
                        ele.style({
                            'font-size': 50,
                        })
                    } else {
                        ele.addClass("hidden");
                        // //TODO if the node's parent is in the finalBelongingParents, make it more invisible
                        // if (finalBelongingParents.includes(ele.data("parent")) ) {
                        //     ele.style({
                        //         'opacity': 0.1,
                        //         'events': 'no',
                        //     })
                        // }
                    }
                });

                setIsTappedNode(true);

            });

            cyRef.current.on("mousedown", "node", (evt) => {
                if (tappedNodeStateRef.current) return;
                console.log('mousedown');
                const node = evt.target;
                if (node.isParent()) return;

                const connectedEdges = node.connectedEdges();
                if (connectedEdges.length === 0) return;
                cyRef.current.edges().forEach((ele) => {
                    if (connectedEdges.some(edge => edge.data("id") === ele.data("id"))) {
                        if (!ele.hasClass("hidden") && !ele.hasClass("highlighted")) {
                            ele.addClass("highlighted");
                        }
                    } else {
                        if (!ele.hasClass("hidden")) {
                            ele.addClass("hidden-dragging");
                        }
                    }
                });
            });

            cyRef.current.on("mouseup", "node", (evt) => {
                if (tappedNodeStateRef.current) return;
                console.log('mouseup');
                const node = evt.target;
                if (node.isParent()) return;

                const connectedEdges = node.connectedEdges();
                if (connectedEdges.length === 0) return;

                cyRef.current.edges().forEach((ele) => {
                    if (ele.hasClass("hidden-dragging")) {
                        ele.removeClass("hidden-dragging");
                    }

                    if (connectedEdges.some(edge => edge.data("id") === ele.data("id"))) {
                        if (ele.hasClass("highlighted")) {
                            ele.removeClass("highlighted");
                        }
                    }
                });
            });

            let dirty = false;
            cyRef.current.on('drag', 'node', (evt) => {
                dirty = true;
            });

            cyRef.current.on('dragfree', 'node', (evt) => {
                // if(tappedNodeStateRef.current) return;
                if (!dirty) return;
                console.log('dragfree');
                dirty = false;
                // sendStartBundlingMsg()
                // setTimeout(
                //     () => {
                //         edgeBundling()
                //     }, 500
                // )
            });

            let isMiddleDown = false;

            const container = cyRef.current.container();

            let lastPos = null;

            container.addEventListener('mousedown', (e) => {
                if (e.button === 1) {
                    isMiddleDown = true;
                    lastPos = { x: e.clientX, y: e.clientY };
                    e.preventDefault();
                }
            });

            container.addEventListener('mouseup', (e) => {
                if (e.button === 1) {
                    isMiddleDown = false;
                    lastPos = null;
                }
            });

            container.addEventListener('mousemove', (e) => {
                if (isMiddleDown && lastPos) {
                    const dx = e.clientX - lastPos.x;
                    const dy = e.clientY - lastPos.y;
                    cyRef.current.panBy({ x: dx, y: dy });
                    lastPos = { x: e.clientX, y: e.clientY };
                }
            });


            // cyRef.current.resize();
            //
            // cyRef.current.fit();

            return () => cyRef.current.destroy();
        },
        // eslint-disable-next-line
        [elements]);

    async function computeEdgeBundling(cy, bundlingParams) {
        if (!cy) return;

        // 1. 提取节点数据
        console.log("提取节点数据...");
        const nodes = cy.nodes().map(n => {
            const pos = n.position();
            return {
                id: n.id(),
                x: pos.x,
                y: pos.y
            };
        });

        // 2. 提取边数据（含 id/source/target）
        console.log("提取边数据...");
        const edges = cy.edges().map(e => ({
            id: e.id(),
            source: e.source().id(),
            target: e.target().id()
        }));

        // 3. 构造请求体
        console.log("构造请求体...");
        const payload = {
            nodes,
            edges,
            params: {
                bandwidth: bundlingParams.bandwidth,
                decay: bundlingParams.decay,
                iterations: bundlingParams.iterations,
                union: bundlingParams.union,
            }
        };


        console.log("发送请求到 bundling 服务...");
        // const url = 'http://localhost:8527/bundle'; // 确保这个 URL 是正确的
        const url = 'https://fdeb.monsterlady.io/bundle'; // 生产环境的 URL
        const res = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
        });

        if (!res.ok) throw new Error(`Failed to fetch bundling: ${res.status}`);
        // 4. 应用结果（你可以处理 data.paths）
        // console.log("Bundled paths:", data.paths);
        // return data.paths;

        console.log("处理 bundling 结果...");
        return await res.json();

    }

    // update edge shape on slider change
    const [bundlingStrength, setBundlingStrength] = useState(0);
    // 本地 slider 值（0–100）
    const [sliderValue, setSliderValue] = useState(bundlingStrength * 100);

    // 当外部 bundlingStrength 变化时，同步到 slider
    useEffect(() => {
        setSliderValue(bundlingStrength * 100);
    }, [bundlingStrength]);

    useEffect(() => {
        if (!cyRef.current) return;

        cyRef.current.batch(() => {
            console.log("Updating edge bundling strength to:", bundlingStrength);
            cyRef.current.edges().forEach(edge => {
                if(bundlingStrength === 0){
                    // 如果 bundlingStrength 为 0，直接使用直线
                    edge.data('segmentDistances', [0]);
                    edge.data('segmentWeights', [0.5]);
                   // 直接返回，不需要计算曲线距离和权重
                    return;
                }
                if (bundlingStrength === 1) {
                    // 如果 bundlingStrength 为 1，直接使用曲线距离和权重
                    edge.data('segmentDistances', edge.data('curvedDistances'));
                    edge.data('segmentWeights', edge.data('curvedWeights'));
                    return;

                }
                const curvedDistances = edge.data('curvedDistances');
                const curvedWeights = edge.data('curvedWeights');
                // 如果没有od和ow数据，则直接返回
                if (!curvedDistances || !curvedWeights) return;


                const straightDists = edge.data('straightDistances');
                const straightWeights = edge.data('straightWeights');

                const dists = curvedDistances.map((d, i) => d * bundlingStrength + straightDists[i] * (1 - bundlingStrength));
                const weights = curvedWeights.map((w, i) => w * bundlingStrength + straightWeights[i] * (1 - bundlingStrength));
                edge.data('segmentDistances', dists);
                edge.data('segmentWeights', weights);
            });
        });
    }, [bundlingStrength]);

    useEffect(() => {
        const handleKeyDown = (event) => {
            // event.key 在不同布局下会区分大小写，建议统一 toLowerCase() 再比较
            if (event.key.toLowerCase() === '`') {
                console.log('你按下了 ` 键！');
                // 在这里执行你想要的逻辑
                sendStartBundlingMsg()
                setTimeout(
                    () => {
                        edgeBundling()
                    }, 500
                )
            }
        };

        window.addEventListener('keydown', handleKeyDown);

        // 清理工作：组件卸载时移除监听
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
        // eslint-disable-next-line
    }, []); // 空依赖数组，确保只绑定一次

    // const [detailNode, setDetailNode] = useState(null);

    return (
        <div
            style={{position: "absolute", width: "100%", height: "80vh"}}>
            {contextHolder}
            {/*search bar*/}
            <AutoComplete
                style={{
                    width: 500,
                    position: "absolute", top: 10, left: "50%", transform: "translateX(-50%)",
                    zIndex: 1000,
                }}
                options={searchOptions}
                onSearch={handleSearchBarSearch}
                onSelect={handleSearchBarSelect}
                placeholder="Search by Name or UUID"
                popupMatchSelectWidth={false}
            >
                <Input size="large" allowClear/>
            </AutoComplete>

            {/*options component*/}
            <Popover content={
                <Spin tip="Loading..."
                      spinning={loading}
                >
                    <h1>Staff Option</h1>
                    <Radio.Group
                        block
                        options={staffOptions}
                        defaultValue="Default"
                        optionType="button"
                        buttonStyle="solid"
                        onChange={
                            handleStaffOptionChange
                        }
                        size="large"
                        style={{
                            // left and right padding
                            padding: "20px",
                        }}
                    />
                    <h1>Cooperative Relationship Option</h1>
                    <Radio.Group
                        block
                        options={edgeOptions}
                        defaultValue="Default"
                        optionType="button"
                        buttonStyle="solid"
                        onChange={
                            handleEdgeOptionChange
                        }
                        size="large"
                        style={{
                            // left and right padding
                            padding: "20px",
                            paddingBottom: "20px"
                        }}
                    />
                    <h1>Edge Bundling Type</h1>
                    <Switch checkedChildren="Union"
                            unCheckedChildren="separate"
                            defaultValue={unionMode}
                            value={unionMode}
                            style={{
                                // left and right padding
                                marginLeft: "20px",
                                marginBottom: "20px"
                            }}
                            onChange={(v)=>{
                                hasInteractedRef.current = true;
                                setUnionMode(v);
                            }} />
                    <h1>Edge Bundling Strength</h1>
                    <Slider
                        value={sliderValue}
                        // 拖动时只更新本地值，不触发 Cytoscape 重绘
                        onChange={value => {
                            setSliderValue(value);
                        }}
                        // 拖拽结束（或松手）时，才真正更新 bundlingStrength
                        onChangeComplete={value => {
                            setBundlingStrength(value / 100);
                        }}
                    />
                    <bar/>
                </Spin>}>
                <div
                    style={{
                        position: "absolute", top: 10, left: "65%", transform: "translateX(-50%)",
                        zIndex: 1000, textAlign: "center", display: "flex",
                    }}
                >

                    {/* 小按钮（⚙ 设置图标） */}
                    <div
                        style={{
                            width: 40, height: 40,
                            background: "#f0f0f0", borderRadius: "50%",
                            display: "flex", alignItems: "center", justifyContent: "center",
                            cursor: "pointer", boxShadow: "0 2px 4px rgba(0,0,0,0.2)"
                        }}
                    >
                        <SettingOutlined style={{fontSize: 20, color: "#555"}}/>
                    </div>

                </div>
            </Popover>

            <Flex vertical gap="middle">
                <Divider orientation="left">Cooperative Relationship Type</Divider>
                <Space direction="horizontal">
                    {
                        Object.keys(colors).map((color) => (
                            <Space key={color}>
                                <Badge color={color} text={colors[color]}/>
                            </Space>
                        ))
                    }
                </Space>
            </Flex>

            <div ref={containerRef} style={{
                marginLeft: '20px',
                marginRight: '20px',
                marginTop: '20px',
                center: "center",
                width: "98%",
                height: "95%",
                border: "1px solid #000",
                borderRadius: "10px",
                backgroundColor: "#f0f0f0",  // 让背景有一个淡色
                backgroundImage: "radial-gradient(circle, rgba(0, 0, 0, 0.2) 2px, transparent 2px)",
                backgroundSize: "20px 20px",  // 控制点的间距
                overflow: "visible"  // 确保内容不会被裁剪
            }}/>


            {/* 右侧 Drawer */}
            <Drawer
                title={`${getTeacherNameByUUID(selectedNodeUUID)} - ${getTeacherByUUID(selectedNodeUUID) ? getTeacherByUUID(selectedNodeUUID).departments : 'null'}`}
                placement="right"
                mask={false}
                width={550}
                onClose={() => handleCloseDrawer()}
                open={drawerVisible}
                onBlur={() => handleCloseDrawer()}
                destroyOnClose={true}
            >
                {selectedNode ? (
                    <div>
                        {/*<Divider ref={personalInfoRef}>{<h2>Personal Details</h2>}</Divider>*/}

                        {/*<Title level={5}>Department</Title>*/}
                        {/*<Text>{getTeacherByUUID(selectedNodeUUID).departments}</Text>*/}

                        {/*<Title level={5}>Name</Title>*/}
                        {/*<Text>{getTeacherNameByUUID(selectedNodeUUID)}</Text>*/}


                        {/*<Title level={5}>UUID</Title>*/}
                        {/*<Text copyable>{selectedNodeUUID}</Text>*/}

                        {/*<Divider>{<h2>3D view</h2>}</Divider>*/}
                        {/*<Divider orientation="left">Legnd</Divider>*/}
                        {/*<Space direction="horizontal">*/}
                        {/*    {*/}
                        {/*        Object.keys({*/}
                        {/*            'cyan': 'Teaching',*/}
                        {/*            'yellow': 'Selected Staff',*/}
                        {/*            'grey': 'Staff',*/}
                        {/*            'green': 'Research',*/}
                        {/*        }).map((color) => (*/}
                        {/*            <Space key={color}>*/}
                        {/*                <Badge color={color} text={{*/}
                        {/*                    'cyan': 'Teaching',*/}
                        {/*                    'yellow': 'Selected Staff',*/}
                        {/*                    'grey': 'Staff',*/}
                        {/*                    'green': 'Research',*/}

                        {/*                }[color]}/>*/}
                        {/*            </Space>*/}
                        {/*        ))*/}
                        {/*    }*/}
                        {/*</Space>*/}
                        <div style={{
                            border: '5px solid #ddd',
                            borderRadius: 10,
                            padding: 10,
                        }}>
                            {/*<PowerGrid jsonData={{*/}
                            {/*    key: selectedNodeUUID,*/}
                            {/*    content: selectedNode*/}
                            {/*}}*/}
                            {/*           scrollToTop={scrollToTop}*/}
                            {/*           scrollToBottom={scrollToBottom}*/}
                            {/*/>*/}

                            {/*{drawerVisible && (<ConcentricGraph jsonData={{*/}
                            {/*    key: selectedNodeUUID,*/}
                            {/*    content: selectedNode*/}
                            {/*}} />)}*/}
                            <ConcentricGraph jsonData={{key: selectedNodeUUID, content: selectedNode}}/>

                        </div>

                        {/*<Divider ref={cooperativeRelationshipRef}>{<h2>Detail</h2>}</Divider>*/}

                        {/*<Segmented*/}
                        {/*    options={[*/}
                        {/*        {*/}
                        {/*            label: (*/}
                        {/*                <div style={{ padding: 4 }}>*/}
                        {/*                    <Avatar src="https://api.dicebear.com/7.x/miniavs/svg?seed=8" />*/}
                        {/*                    <div>User 1</div>*/}
                        {/*                </div>*/}
                        {/*            ),*/}
                        {/*            value: 'staff',*/}
                        {/*        },*/}
                        {/*        {*/}
                        {/*            label: (*/}
                        {/*                <div style={{ padding: 4 }}>*/}
                        {/*                    <Avatar style={{ backgroundColor: '#f56a00' }}>K</Avatar>*/}
                        {/*                    <div>User 2</div>*/}
                        {/*                </div>*/}
                        {/*            ),*/}
                        {/*            value: 'research',*/}
                        {/*        },*/}
                        {/*        {*/}
                        {/*            label: (*/}
                        {/*                <div style={{ padding: 4 }}>*/}
                        {/*                    <Avatar style={{ backgroundColor: '#87d068' }} icon={<UserOutlined />} />*/}
                        {/*                    <div>User 3</div>*/}
                        {/*                </div>*/}
                        {/*            ),*/}
                        {/*            value: 'teaching',*/}
                        {/*        },*/}
                        {/*    ]}*/}
                        {/*    defaultValue={'staff'}*/}
                        {/*    value={()=>{*/}
                        {/*        if (detailNode){*/}
                        {/*            console.log("Detail Node: ", detailNode);*/}
                        {/*            if (detailNode.data.id.startsWith('y')){*/}
                        {/*                return 'staff';*/}
                        {/*            }*/}
                        {/*            if (detailNode.data.id.startsWith('r')){*/}
                        {/*                return 'research';*/}
                        {/*            }*/}
                        {/*            if (detailNode.data.id.startsWith('t')){*/}
                        {/*                return 'teaching';*/}
                        {/*            }*/}
                        {/*        }*/}
                        {/*    }}*/}
                        {/*/>*/}

                        {/*<Divider ref={cooperativeRelationshipRef}>{<h2>Cooperative Relationships</h2>}</Divider>*/}

                        {/*{selectedNode.map(*/}
                        {/*    // eslint-disable-next-line array-callback-return*/}
                        {/*    (item, index) => {*/}
                        {/*        if (item.partnerUUID === selectedPartnerUUID) {*/}
                        {/*            return <div key={index}*/}
                        {/*                        style={{*/}
                        {/*                            marginBottom: 20,*/}
                        {/*                            borderBottom: '1px solid #ddd',*/}
                        {/*                            paddingBottom: 10*/}
                        {/*                        }}>*/}
                        {/*                <CooperativeRelationshipItem data={item}/>*/}
                        {/*            </div>*/}
                        {/*        }*/}
                        {/*    }*/}
                        {/*)}*/}

                    </div>
                ) : (
                    <p>No Cooperative connections Info Available</p>
                )}
            </Drawer>
        </div>
    );
};

export default CytoscapeGraph;
